import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/web.timers.js";
import { useWindowSize } from '@vueuse/core';
import FullscreenGalleryContent from './FullscreenGalleryContent.vue';
import { GALLERY_EMIT_ERROR_INJECTION, GALLERY_IS_COMPARE_ACTIVE_INJECTION } from './constants';
export default defineComponent({
  name: 'FullscreenGallery',
  components: {
    FullscreenGalleryContent: FullscreenGalleryContent
  },
  props: {
    downloadable: {
      type: Boolean,
      default: true
    },
    printable: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: false
    },
    comparable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['hide', 'delete', 'error', 'document:open'],
  setup: function setup(props, _ref) {
    var expose = _ref.expose,
      emit = _ref.emit;
    var isActive = ref(false);
    var activationKey = ref(Date.now());
    var innerFiles = ref([]);
    var activeGalleries = ref({
      left: {
        isActive: true,
        fileIndex: 0
      },
      right: {
        isActive: false,
        fileIndex: 0
      }
    });
    var leftGallery = ref(null);
    var rightGallery = ref(null);
    var _useNuxtApp = useNuxtApp(),
      $device = _useNuxtApp.$device;
    var _useWindowSize = useWindowSize(),
      windowWidth = _useWindowSize.width,
      windowHeight = _useWindowSize.height;
    provide(GALLERY_EMIT_ERROR_INJECTION, function (e) {
      return emit('error', e);
    });
    provide(GALLERY_IS_COMPARE_ACTIVE_INJECTION, readonly(computed(function () {
      return isBothGalleriesActive.value;
    })));
    var isBothGalleriesActive = computed(function () {
      return activeGalleries.value.left.isActive && activeGalleries.value.right.isActive;
    });
    var width = computed(function () {
      return isBothGalleriesActive.value ? windowWidth.value / 2 - 2 : windowWidth.value;
    });
    var height = computed(function () {
      return windowHeight.value;
    });
    var isCompareBtnVisible = computed(function () {
      return !isBothGalleriesActive.value && props.comparable && !$device.isMobile && innerFiles.value.length > 1;
    });
    function handleHideGallery(key) {
      if (isBothGalleriesActive.value) {
        activeGalleries.value[key].isActive = false;

        // Этот обработчик вызывается засчёт нажатия, которое уже вызывает блюр, поэтому надо дождаться следующего макротаска, чтобы совершить фокус
        setTimeout(function () {
          var _leftGallery$value, _rightGallery$value;
          (_leftGallery$value = leftGallery.value) === null || _leftGallery$value === void 0 ? void 0 : _leftGallery$value.focus();
          (_rightGallery$value = rightGallery.value) === null || _rightGallery$value === void 0 ? void 0 : _rightGallery$value.focus();
        });
        return;
      }
      hide();
    }
    function handleShowGallery(key) {
      activeGalleries.value[key].isActive = true;
      // Этот обработчик вызывается засчёт нажатия, которое уже вызывает фокус, поэтому надо дождаться следующего макротаска, чтобы совершить блюр
      setTimeout(function () {
        var _leftGallery$value2, _rightGallery$value2;
        (_leftGallery$value2 = leftGallery.value) === null || _leftGallery$value2 === void 0 ? void 0 : _leftGallery$value2.blur();
        (_rightGallery$value2 = rightGallery.value) === null || _rightGallery$value2 === void 0 ? void 0 : _rightGallery$value2.blur();
      });
    }
    function show(_x, _x2) {
      return _show.apply(this, arguments);
    }
    function _show() {
      _show = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(files, fromIndex) {
        var compare,
          _leftGallery$value3,
          _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              compare = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
              innerFiles.value = files;
              activationKey.value = Date.now();
              isActive.value = true;
              activeGalleries.value.left.isActive = true;
              activeGalleries.value.left.fileIndex = fromIndex !== null && fromIndex !== void 0 ? fromIndex : 0;
              activeGalleries.value.right.isActive = compare && props.comparable && !$device.isMobile;
              activeGalleries.value.right.fileIndex = fromIndex !== null && fromIndex !== void 0 ? fromIndex : 0;
              if (isBothGalleriesActive.value) {
                _context.next = 12;
                break;
              }
              _context.next = 11;
              return nextTick();
            case 11:
              (_leftGallery$value3 = leftGallery.value) === null || _leftGallery$value3 === void 0 ? void 0 : _leftGallery$value3.focus();
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _show.apply(this, arguments);
    }
    function hide() {
      isActive.value = false;
      emit('hide');
    }
    function removeIndexes(index, count) {
      innerFiles.value.splice(index, count);
      if (!innerFiles.value.length) {
        hide();
        return;
      }
      correctGalleryIndexAfterRemove(activeGalleries.value.left, index, count);
      correctGalleryIndexAfterRemove(activeGalleries.value.right, index, count);
    }
    function addFiles(files) {
      var _innerFiles$value;
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      (_innerFiles$value = innerFiles.value).splice.apply(_innerFiles$value, [index, 0].concat(_toConsumableArray(files)));
      correctGalleryIndexAfterAdded(activeGalleries.value.left, index, files.length);
      correctGalleryIndexAfterAdded(activeGalleries.value.right, index, files.length);
    }
    function correctGalleryIndexAfterRemove(gallery, index, count) {
      var lastDeletedIndex = index + count - 1;
      if (gallery.fileIndex > lastDeletedIndex) {
        gallery.fileIndex -= count;
      } else if (gallery.fileIndex >= index) {
        gallery.fileIndex = index < innerFiles.value.length ? index : index - 1;
      }
    }
    function correctGalleryIndexAfterAdded(gallery, index, count) {
      if (gallery.fileIndex >= index) {
        gallery.fileIndex += count;
      }
    }
    expose({
      show: show,
      hide: hide,
      removeIndexes: removeIndexes,
      addFiles: addFiles
    });
    return {
      leftGallery: leftGallery,
      rightGallery: rightGallery,
      handleHideGallery: handleHideGallery,
      handleShowGallery: handleShowGallery,
      activeGalleries: activeGalleries,
      isCompareBtnVisible: isCompareBtnVisible,
      innerFiles: innerFiles,
      hide: hide,
      activationKey: activationKey,
      isActive: isActive,
      isBothGalleriesActive: isBothGalleriesActive,
      width: width,
      height: height
    };
  }
});